export const AppProduct = {
    productName: 'SecureMail',
    companyProductName: 'Fiducial SecureMail',
};

export default AppProduct;